import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import React from "react";
import { getLegalEntities, useBookingByIdWithMetaQueryObserver } from "../../../../../../../api/services";
import { FormAutocomplete, FormTextField } from "../../../../../../../components/fields";
import { IFormValues } from "../../../../../types";
import { useQuery } from "@tanstack/react-query";
import { ReactQueryKey, RouteParams } from "../../../../../../../types";
import { useFormContext } from "react-hook-form";

const LegalFormField = () => {

    const { t } = useTranslation('booking');

    const legalFormQuery = useQuery({
        queryKey: [ReactQueryKey.LegalForm],
        queryFn: getLegalEntities,
        refetchOnMount: false
    });

    return (
        <FormAutocomplete<IFormValues>
            name="bookingOwnerDetails.legalEntity"
            label={t('label.legalForm')}
            options={legalFormQuery.data ?? []}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            getOptionLabel={(option) => { return !!option.label ?  t(`legalForms.${option.label}`) : ''}}
            readOnly={true}
        />
    )
}

const BookingOwnerDetails = () => {

    const { t } = useTranslation('booking');

    const { id } = useParams<RouteParams>();

    const bookingByIdQuery = useBookingByIdWithMetaQueryObserver(id);

        const { watch } = useFormContext<IFormValues>();
        const siren = watch(`bookingOwnerDetails.siren`);
        const siret = watch(`bookingOwnerDetails.siret`);
        const vatNumberCountry = watch(`bookingOwnerDetails.vatNumberCountry`);
        const residenceCountry = watch(`bookingOwnerDetails.residenceCountry`);
        const billingCountry_code = watch(`billingOwnerDetails.billingCountry`);
    
        console.log('BookingOwnerDetails vatNumberCountry.code: ' + vatNumberCountry);
        console.log('BookingOwnerDetails residenceCountry: ' + residenceCountry);
    
    
        const checkSirenVisibility = () =>{
            let visibility = !!vatNumberCountry ? vatNumberCountry === "FR" : billingCountry_code === "FR";
            return visibility;
        }

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="h5">
                    {t('label.bookingOwner')}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    {bookingByIdQuery.data?.booking.bookingOwner &&
                        <>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.id"
                                    label={t('label.id')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.firstName"
                                    label={t('label.firstName')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.lastName"
                                    label={t('label.lastName')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.birthDate"
                                    label={t('label.birthDate')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.birthNation"
                                    label={t('label.nationOfBirth')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.birthPlace"
                                    label={t('label.placeOfBirth')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.residenceCountry"
                                    label={t('label.countryOfResidence')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.fiscalCode"
                                    label={t('label.fiscalCode')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.drivingLicenseNumber"
                                    label={t('label.drivingLicenseNumber')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.email"
                                    label={t('label.email')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.mobilePrefix"
                                    label={t('label.prefix')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.mobile"
                                    label={t('label.mobile')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                        </>
                    }
                    {bookingByIdQuery.data?.booking.bookingCompanyOwner &&
                        <>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.id"
                                    label={t('label.id')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <LegalFormField />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.companyName"
                                    label={t('label.companyName')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.country"
                                    label={t('label.country')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.city"
                                    label={t('label.city')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.streetName"
                                    label={t('label.streetName')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.streetNumber"
                                    label={t('label.streetNumber')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.postalCode"
                                    label={t('label.postalCode')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.email"
                                    label={t('label.email')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            {!checkSirenVisibility() &&
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.certifiedEmailAddress"
                                    label={t('label.certifiedEmailAddress')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            }
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.telephone"
                                    label={t('label.telephone')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.mobilePrefix"
                                    label={t('label.prefix')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.mobile"
                                    label={t('label.mobile')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            {(bookingByIdQuery.data?.booking?.invoiceCompany?.publicAuthority === '0' && !checkSirenVisibility()) &&
                                <Grid item xs={12} sm={6}>
                                    <FormTextField<IFormValues>
                                        name="bookingOwnerDetails.sdiCode"
                                        label={t('label.invoiceCode')}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                    />
                                </Grid>
                            }
                            {bookingByIdQuery.data?.booking?.bookingCompanyOwner?.publicAuthority === '1' &&
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <FormTextField<IFormValues>
                                            name="bookingOwnerDetails.publicAuthority"
                                            label={t('label.publicAuthority')}
                                            InputProps={{
                                                readOnly: true
                                            }}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormTextField<IFormValues>
                                            name="bookingOwnerDetails.paIdNumber"
                                            label={t('label.paIdNumber')}
                                            InputProps={{
                                                readOnly: true
                                            }}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                        />
                                    </Grid>
                                </>
                            }
                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.vatNumberCountry"
                                    label={t('label.vatNumberCountry')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.vatNumber"
                                    label={t('label.vatNumber')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                            {//TODO siren --> check Visibilita'
                                checkSirenVisibility() && (         
                              <Grid item xs={12} sm={6}>
                              <FormTextField<IFormValues>
                                name="billingOwnerDetails.siren"
                                label={t("label.siren")}
                                InputProps={{
                                    readOnly: true}}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    />
                                </Grid>)
                                }
                          {//TODO siret --> check Visibilita'
                                checkSirenVisibility() && (         
                            <Grid item xs={12} sm={6}>
                            <FormTextField<IFormValues>
                                name="billingOwnerDetails.siret"
                                label={t("label.siret")}
                                InputProps={{
                                    readOnly: true
                                }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                                />
                                </Grid>)
                                }

                            <Grid item xs={12} sm={6}>
                                <FormTextField<IFormValues>
                                    name="bookingOwnerDetails.fiscalCode"
                                    label={t('label.fiscalCode')}
                                    InputProps={{
                                        readOnly: true
                                    }}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
};

export default BookingOwnerDetails;
